import { useEffect, useRef } from "react";

function Constellation() {
  const ref = useRef(null);
  useEffect(() => {
    const cv = ref.current, ctx = cv.getContext("2d");
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let w, h, pts, raf, dpr = Math.min(window.devicePixelRatio || 1, 2);
    const init = () => {
      w = cv.clientWidth; h = cv.clientHeight;
      cv.width = w * dpr; cv.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const n = Math.round(Math.min(22, Math.max(10, (w * h) / 70000)));
      pts = Array.from({ length: n }, () => ({
        x: Math.random() * w, y: Math.random() * h,
        vx: (Math.random() - 0.5) * 0.4, vy: (Math.random() - 0.5) * 0.4,
        r: Math.random() * 1.1 + 0.4, t: Math.random() * Math.PI * 2,
      }));
    };
    const link = w => (w < 768 ? 180 : 280);
    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      ctx.save();
      const ex = document.querySelector("[data-constellation-exclude]")?.getBoundingClientRect();
      if (ex && ex.bottom > 0 && ex.top < h) {
        ctx.beginPath(); ctx.rect(0, 0, w, h); ctx.rect(ex.left, ex.top, ex.width, ex.height);
        ctx.clip("evenodd");
      }
      const L = link(w);
      for (let i = 0; i < pts.length; i++) {
        const a = pts[i];
        for (let j = i + 1; j < pts.length; j++) {
          const b = pts[j], d = Math.hypot(a.x - b.x, a.y - b.y);
          if (d < L) {
            ctx.strokeStyle = `rgba(103,242,179,${(1 - d / L) * 0.3})`;
            ctx.lineWidth = 0.6;
            ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke();
          }
        }
      }
      for (const p of pts) {
        p.t += 0.015;
        const o = 0.25 + 0.3 * (0.5 + 0.5 * Math.sin(p.t));
        ctx.fillStyle = `rgba(230,255,244,${o})`;
        ctx.shadowColor = "rgba(103,242,179,0.6)"; ctx.shadowBlur = 6;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2); ctx.fill();
        ctx.shadowBlur = 0;
        if (!reduce) {
          p.x += p.vx; p.y += p.vy;
          if (p.x < -10) p.x = w + 10; if (p.x > w + 10) p.x = -10;
          if (p.y < -10) p.y = h + 10; if (p.y > h + 10) p.y = -10;
        }
      }
      ctx.restore();
      if (!reduce) raf = requestAnimationFrame(draw);
    };
    init(); draw();
    const onResize = () => { cancelAnimationFrame(raf); init(); draw(); };
    window.addEventListener("resize", onResize);
    return () => { cancelAnimationFrame(raf); window.removeEventListener("resize", onResize); };
  }, []);
  return <canvas ref={ref} className="absolute inset-0 w-full h-full" data-testid="constellation-canvas" />;
}

export const AmbientLights = () => (
  <div aria-hidden className="pointer-events-none fixed inset-0 -z-10 overflow-hidden" data-testid="ambient-lights">
    <div className="al-orb" style={{ top: "18%", left: "62%", animationDelay: "-4s" }} />
    <div className="al-orb al-orb-sm" style={{ top: "64%", left: "8%", animationDelay: "-9s" }} />
    <Constellation />
  </div>
);
